import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common/Icon';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { ReportsDateRangeValue } from './types';

interface DateRangeControlsProps {
  value: ReportsDateRangeValue;
  onChange: (value: ReportsDateRangeValue) => void;
}

export function DateRangeControls({ value, onChange }: DateRangeControlsProps) {
  const { t } = useTranslation('reports');

  return (
    <div className="flex items-end gap-3 flex-wrap">
      <div className="space-y-1.5">
        <Label htmlFor="reports-date-from">
          <Icon name="Filter" className="inline mr-1" />
          {t('reports:dateRange.fromLabel')}
        </Label>
        <Input
          id="reports-date-from"
          type="date"
          value={value.dateFrom}
          onChange={function changeFrom(event) {
            onChange({ dateFrom: event.target.value, dateTo: value.dateTo });
          }}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="reports-date-to">{t('reports:dateRange.toLabel')}</Label>
        <Input
          id="reports-date-to"
          type="date"
          value={value.dateTo}
          onChange={function changeTo(event) {
            onChange({ dateFrom: value.dateFrom, dateTo: event.target.value });
          }}
        />
      </div>
    </div>
  );
}
